module.exports = __webpack_public_path__ + "ae4a0932116ddf08714a20cbd2bf71da.png";